import { jsx, jsxs } from "react/jsx-runtime";
import "../../Button/Button.js";
import "../../InputControl/InputControl.js";
import "../../InputControl/Input/InputBase.js";
import "../../PhoneInputControl/PhoneInputControl.js";
import "../../PhoneInputControl/PhoneInput/PhoneInput.js";
import "../../IconButton/IconButton.js";
import { useState, useCallback } from "react";
import "../../common/ControlBody.js";
import { ClickAwayListener, Box, Popper, Stack } from "@mui/material";
import "../Select/context/SelectContext.js";
import "../../Dialog/Dialog.js";
import "../../IconButtonNew/IconButton.js";
import "../../../icons/24/Action/Close.js";
import "../../../icons/24/Arrow/ChevronLeft.js";
import { inheritDataTestId } from "../../../utils/dataTestId.js";
import "../Select/components/SelectInput/SelectInput.js";
import { modifiers } from "../Select/PopperModifiers.js";
import "../Select/MultiSelect/context/MultiSelectContext.js";
import "../../../icons/24/System/Check.js";
import "../../../icons/24/Arrow/ChevronDown.js";
import "../../TextareaControl/TextareaControl.js";
import { SearchControl } from "../../SearchControl/SearchControl.js";
import { createEvent } from "../../../utils/createEvent.js";
import "../../../icons/24/System/Search.js";
import "../../FormattedPhone/FormattedPhoneNumber.js";
import "../../Avatar/styles.js";
import "../../CheckboxGroup/Checkbox/styles.js";
import "../../CheckboxGroup/styles.js";
import "../../RadioGroup/Radio/styles.js";
import "../../RadioGroup/styles.js";
import "../../RatingButton/styles.js";
import "../../FloatingActionButton/styles.js";
import "../../SortingButton/styles.js";
import "../../SquareButton/styles.js";
import "../../Toggle/styles.js";
import "../../Dialog/StyledDialog.js";
import "../../Chips/Chip/styles.js";
import "../../ResultMarksNumber/styles.js";
import "../../Progress/ProgressCircle/styles.js";
import "../../Loaders/LoaderCircle/styles.js";
import "../../Loaders/LoaderLine/styles.js";
import "../../SegmentedControl/styles.js";
import "../../ResultMarksText/styles.js";
import "../../Link/styles.js";
import "../../Tag/Tag.js";
import "../../DatePicker/constants.js";
import "../../DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../../DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../../DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../../external/classnames/index.js";
import { Scrollbar } from "../../Scrollbar/Scrollbar.js";
import "../../DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../../DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../../DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../../MobileBottomSheet/MobileBottomSheet.js";
import { ListItem } from "../../List/ListItem/ListItem.js";
import { ListItemText } from "../../List/ListItem/ListItemText.js";
import "../../List/ListItemTree/TreeListItem.js";
import "../../List/ListItemTree/components/Label.js";
import "../../Nowrap.js";
const dummy = () => {
}, Combobox = ({
  getItemData,
  data,
  onChange,
  onInputChange,
  disabled,
  name,
  inputValue,
  ...restProps
}) => {
  const [open, setOpen] = useState(!1), [internalValue, setInternalInputValue] = useState(null), handleFocus = () => {
    disabled || setOpen(!0);
  }, handleClose = useCallback(() => {
    setOpen(!1), window.setTimeout(() => {
      setInternalInputValue(null);
    }, 200);
  }, []), handleSelect = useCallback(
    (val) => {
      onChange == null || onChange(createEvent({ value: val.value, name }), val.value), handleClose();
    },
    [handleClose, name, onChange]
  ), handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setInternalInputValue(value), onInputChange == null || onInputChange(value), value || onChange == null || onChange(createEvent({ value: "", name }), "");
    },
    [name, onChange, onInputChange]
  ), comboboxInput = (setEl) => /* @__PURE__ */ jsx(
    SearchControl,
    {
      inputRef: (el) => setEl(el),
      delay: 300,
      onChange: handleSearch,
      onClick: handleFocus,
      onFocus: handleFocus,
      value: internalValue ?? inputValue,
      autoComplete: "off",
      ...restProps,
      "data-test-id": inheritDataTestId(restProps, "search-control")
    }
  );
  return /* @__PURE__ */ jsx(
    ComboboxDropdown,
    {
      data,
      mapper: getItemData,
      onSelect: handleSelect,
      onClose: handleClose,
      open,
      "data-test-id": inheritDataTestId(restProps, "dropdown"),
      children: (setEl) => comboboxInput(setEl)
    }
  );
}, ComboboxDropdown = ({
  children,
  data,
  mapper,
  onSelect,
  open,
  onClose,
  ...props
}) => {
  const [el, setElement] = useState(null);
  return /* @__PURE__ */ jsx(ClickAwayListener, { onClickAway: open ? onClose : dummy, children: /* @__PURE__ */ jsxs(Box, { className: "click-away-container", children: [
    /* @__PURE__ */ jsx(
      Popper,
      {
        open: !!open,
        anchorEl: el,
        placement: "bottom-start",
        modifiers,
        children: /* @__PURE__ */ jsx(Stack, { sx: styles.dropdownContainer, children: /* @__PURE__ */ jsx(Scrollbar, { "data-test-id": inheritDataTestId(props, "scrollbar"), children: data.map((d, i) => {
          const item = mapper(d);
          return /* @__PURE__ */ jsx(
            ListItem,
            {
              onMouseUp: () => onSelect(item),
              "data-test-id": inheritDataTestId(props, `list-item${i}`),
              children: /* @__PURE__ */ jsx(Stack, { direction: "row", children: /* @__PURE__ */ jsx(ListItemText, { variant: "text", lines: 4, children: item.labelSelection ?? item.label }) })
            },
            item.value
          );
        }) }) })
      }
    ),
    children(setElement)
  ] }) });
}, styles = {
  dropdownContainer: {
    boxShadow: (t) => t.boxShadows.dropdown,
    maxHeight: 300,
    backgroundColor: (t) => t.palette.common.white
  },
  ddContent: {
    backgroundColor: (t) => t.palette.common.white
  }
};
export {
  Combobox
};
//# sourceMappingURL=Combobox.js.map
